// extracted by mini-css-extract-plugin
export var sale = "Sale-module--sale--9DQFL";